import React from "react";
import BannerSection from "../Component/BannerSection";
import Layout from "../Component/Layout/Layout";

const TermsOfUse = () => {
  return (
    <Layout>
      <BannerSection
        title="Home"
        image="/images/product&service_banner.jpeg"
        description="Terms Of Use"
        heading="Terms Of Use"
      />
      <div className="container my-5">
        <h1 className="mb-4 text-start fw-bold">Terms of Use</h1>

        <div className="mb-4">
          <p>
            By accessing or using the Afrikan BBQ website (the{" "}
            <strong>"Site"</strong>), you agree to be bound by these Terms of
            Service (<strong>"Terms"</strong>). If you do not agree to these
            Terms, please do not use the Site.
          </p>
        </div>

        <h2 className="mt-4 mb-3 fw-bold">Use of Site</h2>
        <p>
          You agree to use the Site only for lawful purposes and in a way that
          does not infringe the rights of, restrict, or inhibit anyone else's
          use and enjoyment of the Site. Prohibited behavior includes harassing
          or causing distress or inconvenience to any person, transmitting
          obscene or offensive content, or disrupting the normal flow of
          dialogue within the Site.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Intellectual Property</h2>
        <p>
          All content on the Site, including text, graphics, logos, icons,
          images, audio clips, video clips, digital downloads, data
          compilations, and software, is the property of Afrikan BBQ LLC or its
          content suppliers and is protected by United States and international
          copyright laws. The compilation of all content on this Site is the
          exclusive property of Afrikan BBQ LLC and is protected by U.S. and
          international copyright laws. All software used on this Site is the
          property of Afrikan BBQ LLC or its software suppliers and is protected
          by United States and international copyright laws.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Third-Party Links</h2>
        <p>
          Our website may include links to third-party websites. Afrikan BBQ LLC
          is not responsible for the content or practices of these third-party
          sites.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by applicable law, Afrikan BBQ LLC
          shall not be liable for any indirect, incidental, special,
          consequential, or punitive damages, or any loss of profits or
          revenues, whether incurred directly or indirectly, or any loss of
          data, use, goodwill, or other intangible losses, resulting from:
        </p>
        <ul>
          <li>Your use or inability to use the Site.</li>
          <li>
            Any unauthorized access to or use of our servers and/or any personal
            information stored therein.
          </li>
          <li>
            Any interruption or cessation of transmission to or from the Site.
          </li>
          <li>
            Any bugs, viruses, trojan horses, or the like that may be
            transmitted to or through our Site by any third party.
          </li>
          <li>
            Any errors or omissions in any content or for any loss or damage
            incurred as a result of the use of any content posted, emailed,
            transmitted, or otherwise made available through the Site.
          </li>
          <li>
            User content or the defamatory, offensive, or illegal conduct of any
            third party.
          </li>
        </ul>

        <h2 className="mt-4 mb-3 fw-bold">Governing Law</h2>
        <p>
          These Terms shall be governed and construed in accordance with the
          laws of the State of Washington, without regard to its conflict of law
          provisions.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Changes to These Terms</h2>
        <p>
          Afrikan BBQ LLC reserves the right, at our sole discretion, to modify
          or replace these Terms at any time. If a revision is material, we will
          try to provide at least 30 days' notice prior to any new terms taking
          effect. What constitutes a material change will be determined at our
          sole discretion.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at:
        </p>
        <div className="mb-4">
          <p>
            <strong>Afrikan BBQ LLC</strong>
          </p>
          <p>
            Address:{" "}
            <a
              href="https://www.google.com/maps/place/3118+E+Baldwin+Ave,+Spokane,+WA+99207"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none text-danger"
            >
              3118 E Baldwin Ave, Spokane, WA 99207
            </a>
          </p>
          <p>
            Email:{" "}
            <a
              href="mailto:Info@afrikanbbq.com"
              className="text-decoration-none text-danger"
            >
              Info@afrikanbbq.com
            </a>
          </p>
          <p>
            Phone:{" "}
            <a
              href="tel:+15096012505"
              className="text-decoration-none text-danger"
            >
              509-601-2505
            </a>
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default TermsOfUse;
